export default "__VITE_ASSET__DHgRWZBs__"